import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import CollectionIcon, { StyledCollectionIcon } from './CollectionIcon'

const CollectionName = ({ collection }) => (
	<StyledCollectionName>
		<CollectionIcon color={collection.color} icon={collection.icon} size={20} />
		{collection.name}
	</StyledCollectionName>
)

CollectionName.propTypes = {
	collection: PropTypes.object.isRequired
}

export const StyledCollectionName = styled.div`
	align-items: center;
	display: flex;

	${StyledCollectionIcon} {
		margin-right: 0.35rem;
	}
`

export default CollectionName
